
//Funciones de Colecciones
const createCustomCollection = async (
  title = "",
  metafields = ""
) => {
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      title: title, //string
      metafields: JSON.stringify(metafields)
    })
  };
  const response = await fetch('https://api-zepika.panorama.works/public/api/v1/collections/create-custom', options);
  const collection = await response.json();
  if (!response.ok || collection.status === false) {
    throw new Error(collection.error || collection.message || `No se pudo crear la mesa (${response.status}).`);
  }
  return collection;
};

const updateCollectionTitle = async (
  title = "",
  collection
) => {
  collection = collection + ''
  if (!collection.includes('gid://shopify/Collection/')) {
    collection = 'gid://shopify/Collection/' + collection
  }
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      title: title, //string
      collection_id: collection
    })
  };
  console.log(options)

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/table-title/update', options)
    .then(response => response.json())
    .then((response) => {
      console.log(response)
      collection = response
    })
    .catch(err => console.error(err));
  return collection;
};


async function addCollectionMetafield(collectionId, metafield) {
  var new_metafield;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: collectionId,
      namespace: metafield.namespace,
      key: metafield.key,
      value: metafield.value,
      type: metafield.type
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/add-metafield', options)
    .then(response => response.json())
    .then((response) => {
      console.log(response)
      new_metafield = response
    })
    .catch(err => console.error(err));
  return new_metafield;
}

async function getCollectionMetafield(collectionId) {
  var metafields;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/' + collectionId + '/get-metafields', options)
    .then(response => response.json())
    .then((response) => {
      //console.log(response)
      metafields = response
    })
    .catch(err => console.error(err));
  return metafields;
}

async function createCollectionEvents(
  nombre,
  jerarquia,
  fecha,
  imagen,
  descripcion,
  vestimenta,
  ubicacion,
  requiere
) {
  if (requiere == true) {
    requiere = "true"
  }
  else {
    requiere = "false"
  }
  var collectionObjects;
  console.log(ubicacion);
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      fields: JSON.stringify({
        "fields": [
          {
            "key": "nombre_del_evento",
            "value": nombre
          },
          {
            "key": "jerarquia_de_evento",
            "value": jerarquia
          },
          {
            "key": "fecha_y_hora",
            "value": fecha
          },
          {
            "key": "descripcion",
            "value": descripcion
          },
          {
            "key": "codigo_de_vestimenta",
            "value": vestimenta
          },
          {
            "key": "ubicacion",
            "value": ubicacion
          },
          {
            "key": "requiere_invitacion",
            "value": requiere
          }
        ]
      })
    })
  };
  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/create-collection-event', options)
    .then(response => response.json())
    .then((data) => {
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createEventUbication(nombre, link) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      ubication_name: nombre,
      link_to_google_maps: link
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/create-event-ubication', options)
    .then((response) => response.json())
    .then((data) => {
      console.log("ubicacion");
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createTableReference(collectionId, rol) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: collectionId,
      rol: rol
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/create-table-reference', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createBankData(
  titular,
  clabe,
  banco,
  cuenta
) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      bank_holder: titular,
      clabe: clabe,
      account_number: cuenta,
      bank_name: banco
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/create-bank-data', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createGuestData(eventos, festejado, grupo, acompanantes) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      event_id: eventos,
      celebrated: festejado,
      group: grupo,
      companion: acompanantes
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/create-guest', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createProductObject(productId, qty) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      product_id: productId,
      quantity: qty
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/products/create-product-object', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

const getMetaObjectData = async (id) => {
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      id: JSON.stringify(id)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/metaobjects/get-metaobject', options)
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      userData = data
    })
    .catch((error) => console.error(error));
  return userData;
};

async function publishMetaObject(metaobjectId) {
  await fetch("https://zepika.myshopify.com/admin/api/2023-01/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Access-Token": pass,
    },
    body: JSON.stringify({
      query: `mutation UpdateMetaobject($id: ID!, $metaobject: MetaobjectUpdateInput!) {
    metaobjectUpdate(id: $id, metaobject: $metaobject) {
          metaobject {
            handle
            id
          }
          userErrors {
            field
            message
            code
          }
        }
      }`,
      variables: {
        id: metaobjectId,
        metaobject: {
          capabilities: {
            publishable: {
              status: "ACTIVE",
            },
          },
        },
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    });
}

async function updateMetaObject(metaobjectId, fields) {
  var info
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      metaobject_id: metaobjectId,
      fields: JSON.stringify({ "fields": fields })
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/metaobjects/update-metaobject', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      info = data
    });
  return info
}

//Funciones de Customers




async function verifyCustomer(email, first_name, last_name, country_code = '', phone = '') {
  console.log('---------- Verify Customer ----------')
  console.log(email)
  console.log(first_name)
  console.log(last_name)
  console.log(country_code)
  console.log(phone)
  console.log('---------- Verify Customer ----------')
  var data
  var options
  if (country_code != '' && phone != '') {
    options = {
      method: 'POST',
      body: new URLSearchParams({
        email: email,
        first_name: first_name,
        last_name: last_name,
        country_code: country_code,
        phone: phone
      })
    };
  }
  else {
    options = {
      method: 'POST',
      body: new URLSearchParams({
        email: email,
        first_name: first_name,
        last_name: last_name
      })
    };
  }

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/verify-customer', options)
    .then(response => response.json())
    .then((response) => {
      console.log(response)
      data = response
    })
    .catch(err => console.error(err));
  return data;
}


const sendEmail = async (email, title, id, active, name, name2, admin = 1) => {
  if (id.includes('gid://shopify/Customer/')) {
    id = id.replace('gid://shopify/Customer/', '')
  }
  if (active) {
    active = false
  }
  else {
    active = true
  }
  var collection
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      mail_to: email,
      gift_table: title,
      customer_id: id,
      active: JSON.stringify(active),
      first_name: name,
      name_sender: name2,
      is_admin: admin
    })
  };
  console.log(options)
  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/send-email', options)
    .then(response => response.json())
    .then((response) => {
      console.log(response)
      collection = response
    })
    .catch(err => console.error(err));
  return collection
};

const createNewCustomer = async (name, lastname, email, metafields, tel, tag, tel_code) => {
  console.log(email)
  var options
  if (tel_code) {
    tel_code = tel_code + ''
    tel_code = tel_code.replaceAll('+', '')
  }
  if (tel == '') {
    options = {
      method: 'POST',
      body: new URLSearchParams({
        name: name,
        lastname: lastname,
        email: email,
        metafields: JSON.stringify(metafields),
        tags: JSON.stringify(tag),
        phone: tel,
        country_code: tel_code
      })
    };
  }
  else {
    tel = tel + ' '
    tel = tel.replaceAll(' ', '')
    tel = parseInt(tel)
    var newUser;
    options = {
      method: 'POST',
      body: new URLSearchParams({
        name: name,
        lastname: lastname,
        email: email,
        metafields: JSON.stringify(metafields),
        tags: JSON.stringify(tag),
        phone: tel,
        country_code: tel_code
      })
    };
  }

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/create-customer', options)
    .then(response => response.json())
    .then((response) => {
      console.log(response)
      if (response.status == false) {
        console.log('errores 2')
        if ($('#guestFile-form').length > 0) {
          console.log('muestra el mensaje')
          generalLoader.off()
          $('#guestFile-form').slideUp()
          $('#guestFile-error').text('Hay un error en el archivo que intentaste subir, por favor intenta nuevamente.')
          $('#guestFile-error').slideDown()
          return '0';
        }
      }
      else {
        newUser = response
      }
    })
    .catch(err => console.error(err));
  return newUser;
};

const getCustomerData = async (id) => {
  console.log(id)
  if (!(id + '').includes('gid://shopify/Customer/')) {
    id = 'gid://shopify/Customer/' + id
  }
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      customer_id: id
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/get-customer', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};

const getGuestsData = async (query, tag) => {
  //console.log(query);
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      str_query: query,
      qty: 50
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/get-guest', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      //console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};



const getGuestsData2 = async (query, tag) => {
  //console.log(query);
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      str_query: query,
      qty: 1
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/get-guest', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      //console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};



const getCustomerByEmail = async (email) => {
  var userData;
  console.log(email)
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      email: email
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/get-customer-by-email', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};


const updateCustomer = async (id, firstName, lastName, email) => {
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      customer_id: id,
      name: firstName,
      last_name: lastName,
      email: email
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/update-customer', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};



const updateGuestOld = async (id, name, last_name, email, tel) => {
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      customer_id: id,
      last_name: last_name,
      first_name: name,
      email: email,
      phone: tel
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/update-guest', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};
const updateGuest = async (body) => {
  const url = `${productionUrl}${candidateVersion}/collections/inviation/update`
  const response = await fetchData(url, 'PUT', body)
  return response;
};

const updateCustomerTag = async (id, tag) => {
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      customer_id: id,
      tags: JSON.stringify(tag)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/update-tag', options)
    .then(response => response.json())
    .then((response) => {
      userData = response
      console.log(response)
    })
    .catch(err => console.error(err));
  return userData;
};

const updateCustomerAddress = async (
  address_id,
  user_id,
  address_name,
  address_last_name,
  address_address1,
  address_address2,
  address_postcode,
  address_city,
  address_country,
  address_province,
  address_tel
) => {
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      customer_id: user_id,
      address_id: address_id,
      name: address_name,
      last_name: address_last_name,
      address1: address_address1,
      address2: address_address2,
      zip: address_postcode,
      city: address_city,
      country: address_country,
      province: address_province,
      phone: parseInt(address_tel)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/update-customer-address', options)
    .then(response => response.json())
    .then((response) => {
      address = response
      console.log(response)
    })
    .catch(err => console.error(err));
  return address;
};

async function addCustomerMetafield(userId, metafield) {
  console.log(metafield)
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      customer_id: userId,
      namespace: metafield.namespace,
      key: metafield.key,
      type: metafield.type,
      value: metafield.value
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/add-metafield', options)
    .then(response => response.json())
    .then((response) => {
      console.log(response)
    })
    .catch(err => console.error(err));
}

async function getCustomerMetafield(userId) {
  if (userId.includes('gid://shopify/Customer/')) {
    userId = userId.replace('gid://shopify/Customer/', '')
  }
  var metafields;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/' + userId + '/get-metafield', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.status == false) {
        metafields = []
      } else {
        metafields = data
      }
      //metafields = data;
    })
    .catch(err => console.error(err));
  return metafields;
}

//Funciones de órdenes

async function updateOrderNote(orderId, note) {
  var metafields;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      order_id: orderId,
      note: note
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/orders/update-note', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    });
}

async function addOrdernMetafield(orderId, metafield) {
  var new_metafield;
  console.log(orderId);
  if (orderId.includes('gid://shopify/Order/')) {
    orderId = orderId.replace('gid://shopify/Order/', '')
  }
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      order_id: orderId,
      namespace: metafield.namespace,
      key: metafield.key,
      value: metafield.value,
      type: metafield.type
    })
  };
  console.log(options)
  await fetch('https://api-zepika.panorama.works/public/api/v1/orders/add-metafield', options)
    .then((response) => response.json())
    .then((data) => {
      console.log("Metafield updated:", data);
      new_metafield = data;
    })
    .catch((error) => {
      console.error("Error updating metafield:", error);
    });
  return new_metafield;
}

const getOrderData = async (id) => {
  if (id.includes('gid://shopify/Order/')) {
    id = id.replace('gid://shopify/Order/', '')
  }
  var orderData;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/orders/' + id + '/get-order', options)
    .then((response) => response.json())
    .then((data) => {
      orderData = data;
      console.log(data)
    })
    .catch((error) => {
      console.error("Error updating metafield:", error);
    });
  return orderData;
};

//Funciones de Productos
async function createNewProduct(name, description, product_type, price, image, colId, want) {
  var product;
  console.log(name, description, product_type, price)
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      title: name,
      body_html: description,
      product_type: product_type,
      image: image,
      price: price,
      collection_id: colId,
      quantity: want
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/products/create-new-product', options)
    .then((response) => response.json())
    .then((data) => {
      console.log("Product created:", data);
      product = data
    })
    .catch((error) => console.error(error));
  return product;
}

async function setProductCategory(product) {
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      product_id: product
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/products/set-product-category', options)
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error(error));
}

async function addProductsToCollection(collectionId, products) {
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: collectionId,
      productIds: JSON.stringify(products)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/add-products', options)
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error(error));
}
const removeProductFromCollection = async (collectionId, productIds) => {
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: collectionId,
      productIds: JSON.stringify({ "ids": productIds })
    })
  };

  const response = await fetch('https://api-zepika.panorama.works/public/api/v2/collections/products/remove', options)
    .then((response) => response.json())
    .then((data) => {
      if (data?.status == false) {
        throw new Error(data?.message)
      }
      return data
    })
    .catch((error) => error);
  return response;
}
async function deleteProductsOfCollection(collectionId, productId) {
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: collectionId,
      product_id: productId
    })
  };

  const deletedProduct = await fetch('https://api-zepika.panorama.works/public/api/v1/collections/delete-product', options)
    .then((response) => response.json())
    .then((data) => {
      if (data?.status == false) {
        throw new Error(data?.message)
      }
      return data
    })
    .catch((error) => {
      console.error(error);
      return error
    });
  return deletedProduct;
}

const getProductData = async (id) => {
  id = id + ''
  if (id.includes('gid://shopify/Product/')) {
    id = id.replace('gid://shopify/Product/', '')
  }
  var userData;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/products/' + id + '/get-product', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data)
      userData = data
    })
    .catch((error) => console.error(error));
  return userData;
};

//Funciones de páginas

async function addPageMetafield(pageId, metafield) {
  var new_metafield;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      page_id: pageId,
      namespace: metafield.namespace,
      key: metafield.key,
      type: metafield.type,
      value: metafield.value
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/add-metafield', options)
    .then((response) => response.json())
    .then((data) => {
      console.log("Metafield updated:", data);
      new_metafield = data;
    })
    .catch((error) => {
      console.error("Error updating metafield:", error);
    });
  return new_metafield;
}

const createPage = async (title, metafields) => {
  var collection;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      title: title,
      metafields: JSON.stringify(metafields)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/create-new-page', options)
    .then((response) => response.json())
    .then((data) => {
      collection = data;
      console.log(data);
    })
    .catch((error) => console.error(error));
  return collection;
};

async function createTableHomePage(nombre) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      name: nombre
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/create-table-home', options)
    .then((response) => response.json())
    .then(async (data) => {
      console.log("ubicacion");
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}


async function createInvitationPage(events) {
  var collectionObjects;
  console.log(JSON.stringify(events))
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      events: events
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/create-invitation-page', options)
    .then((response) => response.json())
    .then((data) => {
      console.log("ubicacion");
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createTableStyles() {
  var collectionObjects;
  const options = {
    method: 'POST'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/create-table-style', options)
    .then((response) => response.json())
    .then((data) => {
      console.log("ubicacion");
      console.log(data);
      console.log(data.data.metaobjectCreate.metaobject.id);
      collectionObjects = data.data.metaobjectCreate.metaobject.id;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

//Funciones para subir una imagen a los archivos de Shopify

async function createFileUrl(name) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      name: name
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/files/create-file-url', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      collectionObjects = data;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function createFile(url) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      url: url
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/files/create-file', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      collectionObjects = data;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

async function getLastFile(createdAt) {
  var collectionObjects;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/files/get-last-field', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      collectionObjects = data;
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}

function sanitizeInput(text) {
  text = text.trim();

  text = text.replace(/^\n+|\n+$/g, '');

  text = text.trim();

  return text;
}

async function createGeneralMetaobject(data) {
  console.log(data)
  // Robustez: Shopify rechaza null/undefined en los valores de campo
  // ("Expected value to not be null"). Un campo opcional vacío (título, texto
  // de link, etc.) puede llegar como null desde la carga; lo convertimos a ""
  // para que no rompa el guardado de toda la sección.
  if (Array.isArray(data.fields)) {
    data.fields.forEach(function (f) {
      if (f && (f.value === null || f.value === undefined)) { f.value = ""; }
    });
  }
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      type: data.type,
      fields: JSON.stringify(data.fields)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/metaobjects/create-metaobject', options)
    .then((response) => response.json())
    .then((resp) => {
      // Éxito -> guardamos el ID; cualquier fallo -> null (lo detecta la
      // protección de saveWedsite para no sobreescribir/borrar contenido).
      if (resp && resp.data && resp.data.metaobjectCreate && resp.data.metaobjectCreate.metaobject) {
        collectionObjects = resp.data.metaobjectCreate.metaobject.id;
      } else {
        collectionObjects = null;
      }
    })
    .catch(() => { collectionObjects = null; });
  var metafields;
  return collectionObjects;
}

async function createGeneralMetaobjectSanitized(data) {
  if (Array.isArray(data.fields)) {
    data.fields.forEach(field => {
      // Shopify rechaza null/undefined; un campo opcional vacío se envía como "".
      if (field && (field.value === null || field.value === undefined)) { field.value = ""; }
      if (field.value) {
        field.value = sanitizeInput(field.value);
      }
    });
  }
  console.log('SALIO DE SANITIZAR')
  console.log(data)
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      type: data.type,
      fields: JSON.stringify(data.fields)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/metaobjects/create-metaobject', options)
    .then((response) => response.json())
    .then((resp) => {
      // Éxito -> guardamos el ID; cualquier fallo -> null (lo detecta la
      // protección de saveWedsite para no sobreescribir/borrar contenido).
      if (resp && resp.data && resp.data.metaobjectCreate && resp.data.metaobjectCreate.metaobject) {
        collectionObjects = resp.data.metaobjectCreate.metaobject.id;
      } else {
        collectionObjects = null;
      }
    })
    .catch(() => { collectionObjects = null; });
  var metafields;
  return collectionObjects;
}




async function deletelMetaobject(id) {
  console.log('Entra al deletelMetaobject')
  console.log(id)
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      id: id
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/metaobjects/delete-metaobject', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
}

async function createGuestInvitationObject(evento, status, festejado, grupo, boletos, confirmados) {
  console.log(boletos)
  var collectionObjects;
  options = {
    method: 'POST',
    body: new URLSearchParams({
      event_id: evento,
      celebrated: festejado,
      group: grupo,
      status: status,
      tickets: parseInt(boletos),
      confirm_tickets: parseInt(confirmados)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/create-guest', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.status == false) {
        console.log('hay errores')
        console.log('errores 2')
        if ($('#guestFile-form').length > 0) {
          console.log('muestra el mensaje')
          generalLoader.off()
          $('#guestFile-form').slideUp()
          $('#guestFile-error').text('Hay un error en el archivo que intentaste subir, por favor intenta nuevamente.')
          $('#guestFile-error').slideDown()
          return 0;
        }
      }
      else {
        console.log(data.data.metaobjectCreate.metaobject.id);
        collectionObjects = data.data.metaobjectCreate.metaobject.id;
      }
    })
    .catch((error) => console.error(error));
  var metafields;
  return collectionObjects;
}


async function updateOrder(id, tag) {
  var collectionObjects;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      order_id: id,
      tags: JSON.stringify(tag)
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/orders/update-order', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
  var metafields;
  return
}


/*
const unpublishPage = async (id) => {
  const url = `https://zepika.myshopify.com/admin/api/2023-01/customers/207119551/send_invite.json`;
  var address;
  const data = {
    customer_address: {
      first_name: address_name,
      last_name: address_last_name,
      address1: address_address1,
      address2: address_address2,
      city: address_city,
      province: address_province,
      country: address_country,
      zip: address_postcode,
      phone: address_tel,
      default: true,
    },
  };
  console.log(data);
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Access-Token": pass,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        address = data;
      })
      .catch((error) => console.log(error));
    console.log(response);
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.log(error);
  }
  return address;
};
*/



const getCollectionProducts = async (id) => {
  var userData;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/' + id + '/get-products', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      userData = data
    })
    .catch((error) => console.error(error));
  return userData;
};


async function getPageMetafield(pageId) {
  var metafields;
  const options = {
    method: 'GET'
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/' + pageId + '/get-metafields', options)
    .then((response) => response.json())
    .then((data) => {
      metafields = data;
      console.log(data)
    })
    .catch((error) => {
      console.error("Error getting metafield:", error);
    });
  return metafields;
}



const getOrdersData = async (query) => {
  //console.log(query);
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      str_query: query
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/orders/get-orders-data', options)
    //await fetch('http://127.0.0.1:8000/api/v1/orders/get-orders-data', options)
    .then((response) => response.json())
    .then((data) => {
      userData = data;
      console.log(data)
    })
    .catch((error) => {
      console.error("Error getting metafield:", error);
    });
  return userData;
};


const updateHandle = async (colId, pageId, handle) => {
  var userData;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: colId,
      handle: handle
    })
  };
  const optionsPage = {
    method: 'POST',
    body: new URLSearchParams({
      page_id: pageId,
      handle: handle
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/collections/update-handle', options)
    .then((response) => response.json())
    .then((data) => {
      userData = data;
      console.log(data)
    })
    .catch((error) => {
      console.error("Error updating handle:", error);
    });


  await fetch('https://api-zepika.panorama.works/public/api/v1/pages/update-handle', optionsPage)
    .then((response) => response.json())
    .then((data) => {
      userData = data;
      console.log(data)
    })
    .catch((error) => {
      console.error("Error updating handle:", error);
    });
  return userData;
};


const getGuestsDataBorrar = async (query) => {
  //console.log(query);
  var userData;
  try {
    const response = await fetch(
      "https://zepika.myshopify.com/admin/api/2023-01/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Access-Token": pass,
        },
        body: JSON.stringify({
          query: `query {
          customers(first: 1${query}) {
            pageInfo{
              endCursor
              hasNextPage
            }
            edges {
              node {
                legacyResourceId
                id
                metafields(first:5){
                  edges{
                    node{
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }`,
        }),
      }
    );
    const data = await response.json();
    userData = data;
    console.log(data);
  } catch (error) {
    console.error(error);
  }
  return userData;
};




const getOrdersDataBorrar = async (query) => {
  console.log(query)
  console.log(`orders(first:1${query}`)
  var userData;
  try {
    const response = await fetch(
      "https://zepika.myshopify.com/admin/api/2023-01/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Access-Token": pass,
        },
        body: JSON.stringify({
          query: `query {
                orders(first:1${query}){
                  pageInfo{
                    hasNextPage
                    endCursor
                  }  
                  edges{
                    node{
                      note
                      id
                      name
                      totalPriceSet{
                        shopMoney{
                          amount
                        }
                      }
                      tags
                      email
                      customer{
                        displayName
                      }
                      legacyResourceId
                      createdAt
                      metafields(first:6){
                        edges{
                          node{
                            key
                            value
                          }
                        }
                      }
                      lineItems(first:5){
                        edges{
                          node{
                            title
                            quantity
                            product{
                              productType
                              vendor
                              id
                              legacyResourceId
                              title
                              featuredImage{
                                url
                              }
                              priceRangeV2{
                                maxVariantPrice{
                                  amount
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }`,
        }),
      }
    );
    const data = await response.json();
    userData = data;
    console.log(data);
  } catch (error) {
    console.error(error);
  }
  return userData;
};



//rework this endpoint
async function sendEmailGratitude(giftTo, message, email, giftFrom) {
  // var formdata = new FormData();
  // formdata.append("mailto", email);
  // formdata.append("subject", "Gracias por tu regalo");
  // formdata.append("Recipient", giftFrom);
  // formdata.append("thankSendBy", giftTo);
  // formdata.append("thankMessage", message);

  const body = {
    mailto: email,
    subject: "Gracias por tu regalo",
    Recipient: giftFrom,
    thankSendBy: giftTo,
    thankMessage: message
  }

  // const requestOptions = {
  //   method: 'POST',
  //   body: formdata,
  //   redirect: 'follow'
  // };
  const url = "https://api-zepika.panorama.works/public/api/v1/enviar-agradecimiento"
  const response = fetchData(url, 'POST', body)
  return response
}



async function sendEmailInvitacion(body) {
  const response = await fetchData("https://api-zepika.panorama.works/public/api/v1/enviar-invitacion", 'POST', body)
  return response
  await fetch("https://api-zepika.panorama.works/public/api/v1/enviar-invitacion", requestOptions)
    .then(response => response.text())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
  return
}


async function sendEmailRetiro(name, giftTableName, email, movementNumber, amountToWithdraw, remainingBalance, openingBalance, movementTotal, bankHolder, banKName, clabe, account, metaobjectId, collectionId, totalTableGift) {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  today = dd + '-' + mm + '-' + yyyy;

  const payload = {
    emails: email,
    collection_id: collectionId,
    recipients: name,
    giftTableName: giftTableName,
    remainingBalance: remainingBalance,
    openingBalance: openingBalance,
    amountToWithdraw: amountToWithdraw,
    totalTableGift: totalTableGift,
    movementNumber: parseInt(movementNumber) + 1,
    movementTotal: parseInt(movementTotal),
    contractLink: "https://powerforms.docusign.net/dd252d3d-395f-4d63-a965-02a780480f50?env=na4&acct=925092d9-eb6d-4bfb-8353-c2cc1484d9d4&accountId=925092d9-eb6d-4bfb-8353-c2cc1484d9d4",
    banKName: banKName,
    account: account,
    CLABE: clabe,
    bankHolder: bankHolder,
    withdrawDate: today,
    comfirmTransactionUrl: `https://zepika.com/pages/comprobante-de-retiro?colid=${collectionId}&withdrawdate=${today.replaceAll(' ', '_')}&opening=${parseInt(openingBalance.replaceAll('$', '').replace(',', '').replaceAll(' ', '_'))}&totalgift=${parseInt(totalTableGift.replace('$', '').replace(',', '').replaceAll(' ', '_'))}&amount=${parseInt(amountToWithdraw.replace('$', '').replace(',', '').replaceAll(' ', '_'))}&remaining=${parseInt(remainingBalance.replace('$', '').replace(',', '').replaceAll(' ', '_'))}&movement=${movementNumber.replaceAll(' ', '_')}&total=${movementTotal.replaceAll(' ', '_')}&bank=${banKName.replaceAll(' ', '_')}&account=${account.replaceAll(' ', '_')}&clabe=${clabe.replaceAll(' ', '_')}&holder=${bankHolder.replaceAll(' ', '_')}&retiroid=${metaobjectId}`
  }
  const localUrl = "http://127.0.0.1:8000/api/v1/retiro"
  const prodUrl = "https://api-zepika.panorama.works/public/api/v1/retiro"
  //const response = await getData(localUrl, payload, 'POST');
  const response = await getData(prodUrl, payload, 'POST');

  return response
  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
  };

  await fetch("localUrl", requestOptions)
    .then(response => response.text())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
  return
}

async function getData(url, payload, method, retryCount = 3, retryDelay = 1500) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        const data = await response.json();
        if (data.status) {
          return data;
        } else {
          throw new Error('Error fetching data: ' + JSON.stringify(data));
        }
      } else if (response.status === 429) {
        // Si el código de estado es 429, espera un tiempo antes de reintentar
        console.log(`Request rate limit exceeded, retrying in ${retryDelay}ms...`);
        await new Promise(resolve => setTimeout(resolve, retryDelay));
      } else {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      if (i === retryCount - 1) {
        console.error('There was a problem with the fetch operation:', error);
        return null;  // Devolver null en caso de error repetido
      }
    }
  }
}

// async function sendEmailRetiro(name, col, email, hechos, monto, total, total2, disponibles, titular, banco, clabe, cuenta, retiroId, colId, totalRegalado) {
//   var today = new Date();
//   var dd = String(today.getDate()).padStart(2, '0');
//   var mm = String(today.getMonth() + 1).padStart(2, '0');
//   var yyyy = today.getFullYear();
//   today = dd + '-' + mm + '-' + yyyy;
//   var formdata = new FormData();
//   formdata.append("emails", email);
//   formdata.append("collection_id", colId);
//   formdata.append("recipients", name);
//   formdata.append("giftTableName", col);
//   formdata.append("remainingBalance", total);
//   formdata.append("openingBalance", total2);
//   formdata.append("amountToWithdraw", monto);
//   formdata.append("totalTableGift", totalRegalado);
//   formdata.append("movementNumber", parseInt(hechos) + 1);
//   formdata.append("movementTotal", disponibles);
//   formdata.append("contractLink", "https://powerforms.docusign.net/dd252d3d-395f-4d63-a965-02a780480f50?env=na4&acct=925092d9-eb6d-4bfb-8353-c2cc1484d9d4&accountId=925092d9-eb6d-4bfb-8353-c2cc1484d9d4");
//   formdata.append("banKName", banco);
//   formdata.append("account", cuenta);
//   formdata.append("CLABE", clabe);
//   formdata.append("bankHolder", titular);
//   formdata.append("withdrawDate", formdata);
//   formdata.append("comfirmTransactionUrl", `https://zepika.com/pages/comprobante-de-retiro?colid=${colId}&withdrawdate=${today.replaceAll(' ', '_')}&opening=${parseInt(total2.replaceAll('$', '').replace(',', '').replaceAll(' ', '_'))}&totalgift=${parseInt(totalRegalado.replace('$', '').replace(',', '').replaceAll(' ', '_'))}&amount=${parseInt(monto.replace('$', '').replace(',', '').replaceAll(' ', '_'))}&remaining=${parseInt(total.replace('$', '').replace(',', '').replaceAll(' ', '_'))}&movement=${hechos.replaceAll(' ', '_')}&total=${disponibles.replaceAll(' ', '_')}&bank=${banco.replaceAll(' ', '_')}&account=${cuenta.replaceAll(' ', '_')}&clabe=${clabe.replaceAll(' ', '_')}&holder=${titular.replaceAll(' ', '_')}&retiroid=${retiroId}`);

//   var requestOptions = {
//     method: 'POST',
//     body: formdata,
//     redirect: 'follow'
//   };
//   await fetch("https://api-zepika.panorama.works/public/api/v1/retiro", requestOptions)
//     .then(response => response.text())
//     .then((data) => {
//       console.log(data);
//     })
//     .catch((error) => console.error(error));
//   return
// }




async function sendEmailGift(email, name, nameC, message, products, total, nota, colId) {
  if (nameC.length < 3) {
    for (let i = nameC.length; i < 4; i++) {
      nameC = nameC + '.'
    }
  }
  if (name.length < 3) {
    for (let i = name.length; i < 4; i++) {
      name = name + '.'
    }
  }
  if (message.length < 3) {
    for (let i = message.length; i < 4; i++) {
      message = message + '.'
    }
  }
  console.log(JSON.stringify(products))
  var formdata = new FormData();
  formdata.append("mailto", email);
  formdata.append("subject", "Recibiste un regalo");
  formdata.append("Recipient", name);
  formdata.append("giftsentBy", nameC);
  formdata.append("message", message);
  formdata.append("giftTableLink", "https://zepika.com/account?Dashboard=1");
  formdata.append("profileLink", "https://zepika.com/account");
  formdata.append("products", JSON.stringify(products));
  formdata.append("total", Shopify.formatMoney(total * 100));
  formdata.append("note", nota);
  formdata.append("collection_id", colId);

  var myHeaders = new Headers();
  myHeaders.append("Cookie", "XSRF-TOKEN=eyJpdiI6ImJxbGlWd1lJNUJkQ1dkOUxPOTJ2b0E9PSIsInZhbHVlIjoiV2NNK3lLUW5PZnhUdUprNlM1V3pkaXFUWWdrMXhTRDJoYzBqRVoyQXZmSjcvTzdFWVBCTHBBcmx5WFVXY3ZSSnRXQ21LVlM0SVRBV2dSNTNqK2hGVVNMYndBZWQvcVYvSUZTSW54UzB5RFZhajhlZnNrZzhnL3dBdENOZHlFVHYiLCJtYWMiOiJmMDI4YWZkOWQxYWYyOTJlOWFlM2Q5OGFmNjU1ODc2YzEwNDU3NzFjNTM2ZjQxOGE4ZTk1NjM4NzRjNDMyMmI5IiwidGFnIjoiIn0%3D; zepika_session=eyJpdiI6InF2cHRaT1VLS3FweC9aSldqcGZmV1E9PSIsInZhbHVlIjoiWFpaN1Jxa2RUa2xIaVRub3JWR3hKTlViQmpVMitLL2RKc1h1cys3QUpmNFVDUmlwVGh2U01VUkRWb2g2K3dSRG1XYjRJaDZqblFicVJtVEhSVDdabks2T0sySmJ4cmgvQ1gzb1dMWXdTanp5UW15RnI5N0ZWVFZSdjlJK0EzL3oiLCJtYWMiOiJlMDFmNDhhODE4MmEzYTc2ZDM3Y2ZjMDczMWNlOWYwMDlhMjdlMmFkODc3M2U3YTYwZmRkMDk1MWY4OTYwZWE1IiwidGFnIjoiIn0%3D");
  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
    headers: myHeaders
  };
  await fetch("https://api-zepika.panorama.works/public/api/v1/recibiste-regalo", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
  return
}





async function sendEmailCerrar(colId, email, name, col, totalProducts, products, cashout, titular, banco, clabe, cuenta, address, colId) {
  const today = new Date();
  const day = today.getDate().toString().padStart(2, "0");
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const year = today.getFullYear().toString();
  const formattedDate = `${day}-${month}-${year}`;
  var formdata = new FormData();
  //formdata.append("mailto", email);
  //formdata.append("subject", "Has cerrado tu Mesa de Regalos");
  //formdata.append("Recipient", name);
  formdata.append("collection_id", colId);
  formdata.append("gift_tablename", col);
  //formdata.append("productsSend", totalProducts);
  //formdata.append("productsValue", products);
  //formdata.append("cashOut", cashout);
  //formdata.append("contractLink", "https://www.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=4809a63e-8349-45d4-[…]4edff3&env=na1&acct=b1986e2b-b0a0-4f90-b411-c88d63eb42af&v=2");
  formdata.append("bank_name", banco);
  formdata.append("account", cuenta);
  formdata.append("clabe", clabe);
  formdata.append("bank_holder", titular);
  //formdata.append("address", address);
  //formdata.append("collection_id", colId);
  //formdata.append("close_table_name", name);
  formdata.append("close_date", formattedDate);

  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
  };
  await fetch("https://api-zepika.panorama.works/public/api/v1/cerra-mesa", requestOptions)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
  return
}



async function sendEmailComprobante(email, name, date, opening, withdraw, remaining, movementNumber, movementTotal, titular, banco, clabe, cuenta, totalRegalado) {
  var formdata = new FormData();
  var partes = date.split('-');
  formdata.append("mailto", email);
  formdata.append("subject", "Se ha completado tu retiro");
  formdata.append("Recipient", name);
  formdata.append("withdrawDate", partes[1] + '-' + partes[0] + '-' + partes[2]);
  formdata.append("openingBalance", Shopify.formatMoney(opening * 100));
  formdata.append("amountToWithdraw", Shopify.formatMoney(withdraw * 100));
  formdata.append("remainingBalance", Shopify.formatMoney(remaining * 100));
  formdata.append("movementNumber", parseInt(movementNumber) + 1);
  formdata.append("movementTotal", movementTotal);
  //formdata.append("contractLink", "https://www.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=4809a63e-8349-45d4-[…]4edff3&env=na1&acct=b1986e2b-b0a0-4f90-b411-c88d63eb42af&v=2");
  formdata.append("banKName", banco);
  formdata.append("account", cuenta);
  formdata.append("CLABE", clabe);
  formdata.append("bankHolder", titular);
  formdata.append("totalTableGift", Shopify.formatMoney(totalRegalado * 100));


  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
  };
  await fetch("https://api-zepika.panorama.works/public/api/v1/comprobante-retiro", requestOptions)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
  return
}




async function exportCsvFile(email, colId, name) {
  var formdata = new FormData();
  formdata.append("mail_to", email);
  formdata.append("collection_id", colId);
  formdata.append("name", name);

  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
  };
  await fetch("https://api-zepika.panorama.works/public/api/v1/customers/export/guest-list", requestOptions)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
    })
    .catch((error) => console.error(error));
  return
}



async function getPdfUrl(link, colId) {
  var formdata = new FormData();
  formdata.append("invitation_link", link);
  formdata.append("collection_id", colId);
  var pdf
  console.log(link)

  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
  };
  await fetch("https://api-zepika.panorama.works/public/api/v1/files/get-pdf-by-link", requestOptions)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      pdf = data
    })
    .catch((error) => console.error(error));
  return pdf
}







async function verifyEvents(colId, customerId) {
  var events;
  const options = {
    method: 'POST',
    body: new URLSearchParams({
      collection_id: colId,
      customer_id: customerId
    })
  };

  await fetch('https://api-zepika.panorama.works/public/api/v1/customers/validate-events', options)
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      events = data;
    })
    .catch((error) => console.error(error));
  return events;
}
//Functions 2.0
const productionUrl = 'https://api-zepika.panorama.works/public/api/';
const localUrl = 'http://127.0.0.1:8000/api/'
const currentVersion = 'v1';
const candidateVersion = 'v2';
const updateOrderMetafield = async (orderId, metafield) => {
  const url = `${productionUrl}${currentVersion}/orders/add-metafield`;
  const body = {
    "order_id": orderId,
    "namespace": metafield.namespace,
    "key": metafield.key,
    "value": metafield.value,
    "type": metafield.type
  }
  const response = await fetchNoStatus(url, 'POST', body)
  return response;
}
async function getWithDrawals(collectionId) {
  const url = `${productionUrl}${candidateVersion}/dashboard/gift-table/get-withdraws`;
  const body = {
    "collection_id": collectionId
  }
  const response = await fetchData(url, 'POST', body)
  return response;
}
async function fetchNoStatus(url, method, body, retryCount = 3, retryDelay = 1500) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
      if (response.ok) {
        const data = await response.json();
        return data;
      } else if (response.status === 429) {
        // Si el código de estado es 429, espera un tiempo antes de reintentar
        console.log(`Request rate limit exceeded, retrying in ${retryDelay}ms...`);
        await new Promise(resolve => setTimeout(resolve, retryDelay));
      } else {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      if (i === retryCount - 1) {
        console.error('There was a problem with the fetch operation:', error);
        return null;  // Devolver null en caso de error repetido
      }
    }
  }
}
async function fetchData(url, method = 'GET', body, retryCount = 3, retryDelay = 1500) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(body)
      });
      
      const data = await response.json();
     
      if (response.ok) {
        //const data = await response.json();
        if (data.status === false) {
          throw new Error('Error fetching data: ' + JSON.stringify(data));
        }
        return data; 
      } else if (response.status === 429) {
        // Si el código de estado es 429, espera un tiempo antes de reintentar
        console.log(`Request rate limit exceeded, retrying in ${retryDelay}ms...`);
        await new Promise(resolve => setTimeout(resolve, retryDelay));
      } else if (response.status === 500) {
        console.error('There was a problem with the fetch operation:', response.statusText);
        return { status: false, message: 'Ha ocurrido un error en el servidor, si el error persiste comunicate con soporte' };
      }
    } catch (error) {
      if (i === retryCount - 1) {
        console.error('There was a problem with the fetch operation:', error);
        return null;  // Devolver null en caso de error repetido
      }
    }
  }
}
async function getMetaobjectsAndCustomerLists(collectionId) {
  const { data: metaobjects } = await invitationsObjectList(collectionId);
  const { data: customers } = await customersList(collectionId);
  return [...metaobjects, ...customers];
}
//invitations
async function invitationsObjectList(collectionId) {
  const url = `${productionUrl}${candidateVersion}/collections/inviation/all`;
  const body = {
    "collection_id": collectionId
  }
  const response = await fetchData(url, 'POST', body)
  return response;
}
//guest
async function customersList(collectionId) {
  const url = `${productionUrl}${currentVersion}/customers/guest/list`;
  const body = {
    "collection_id": collectionId
  }
  const response = await fetchData(url, 'POST', body)
  return response;
  // var collectionObjects;
  // const options = {
  //   method: 'POST',
  //   body: new URLSearchParams({
  //     collection_id: colId
  //   })
  // };

  // await fetch('https://api-zepika.panorama.works/public/api/v1/customers/guest/list', options)
  //   .then((response) => response.json())
  //   .then((data) => {

  //     collectionObjects = data;
  //   })
  //   .catch((error) => console.error(error));
  // var metafields;
  // return collectionObjects;
}